var r={LoaderWrapper:"Loader__LoaderWrapper-9Bf",isVisible:"Loader__isVisible-rE5"};export{r as default};
